import { useSelector } from 'react-redux';
import headerHeights from 'config/branding/header-heights';
import useDynamicMainContentTop from '@activebrands/core-web/hooks/useDynamicMainContentTop';
import { styled } from '@activebrands/core-web/libs/styletron';
import { LayoutProps } from '@activebrands/core-web/types/layout';
import Header from 'components/Header';
import Banner from 'components/Header/Banner';
import SkipLinksMenu from '@activebrands/core-web/components/SkiplinksMenu';
import { skiplinksThemes } from 'config/branding/component-themes/skiplinks-themes';
import fm from 'format-message';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100dvh',
});

const Main = styled('main', {
    flex: '1 0 auto',
    scrollMarginTop: 'var(--height-header)'
});

const CheckoutLayout = ({ children, page = {} }: LayoutProps) => {
    const banner = page.data?.content?.banner?.[0] || {};
    const bannerTexts = banner?.texts?.map(text => text?.richText || text);
    const backToSiteLabel = page.data?.content?.backToSiteLabel;
    const hasBanner = bannerTexts?.length > 0;
    const { bannerHeight, headerHeight } = headerHeights;
    const dynamicBannerHeight = hasBanner ? bannerHeight : 0;
    const basketItems = useSelector((state: any) => state.basket.items);
    const numberOfItems = basketItems?.reduce((sum, item) => (sum += item.quantity), 0);
    const isEmptyCheckoutView = numberOfItems < 1;

    return (
        <Wrapper $style={{ paddingTop: `${headerHeight + dynamicBannerHeight}px` }}>
            <SkipLinksMenu 
                links={[{ label: fm('Skip to checkout form'), target: '#main' }]} 
                fontKeys='Miscellaneous/16_100_-1' 
                $style={{...skiplinksThemes.default.menu, ...{scrollMarginTop: '52px'}}} 
                linkStyle={skiplinksThemes.default.link}
            />
            <Header isCheckout backToSiteLabel={backToSiteLabel} theme="default" />
            {hasBanner && <Banner texts={bannerTexts} theme={banner?.theme} to={banner.link?.url} />}
            <Main role="main" id="main" tabIndex={-1}>
                {children}
            </Main>
        </Wrapper>
    );
};

export default CheckoutLayout;
